// Egeez global content (scraped from egeez.com)

// All Typeform URLs mapped to button labels
export const TYPEFORM = {
  joinWaitlist: "https://uu6leb0wjug.typeform.com/to/GeOBEUuR",
  tellMeAnything: "https://uu6leb0wjug.typeform.com/to/XAtQvsOU",
  onboardNow: "https://uu6leb0wjug.typeform.com/to/j7k9u4Ij",
  letsTalk: "https://uu6leb0wjug.typeform.com/to/QPXbLzqD",
  unlockScript: "https://uu6leb0wjug.typeform.com/to/mvqZYpSj",
  tellYourStory: "https://uu6leb0wjug.typeform.com/to/kgDyRi8v",
  signUp: "https://www.elicensee.egeez.com/auth/login/",
};

// Append eGeez UTM params (utm_source=website + utm_page=<page>) to any URL
// while preserving existing query strings and hash fragments.
export function withUTM(url, page) {
  if (!url || typeof url !== "string") return url;
  const utm = `utm_source=website&utm_page=${encodeURIComponent(page)}`;
  // Split out hash fragment (Typeform uses #email=...&name=... for prefill)
  const hashIdx = url.indexOf("#");
  const hash = hashIdx >= 0 ? url.slice(hashIdx) : "";
  const base = hashIdx >= 0 ? url.slice(0, hashIdx) : url;
  // Skip if utm_source already present
  if (/[?&]utm_source=/.test(base)) return url;
  const sep = base.includes("?") ? "&" : "?";
  return `${base}${sep}${utm}${hash}`;
}

export const NAV_LINKS = [
  { label: "Fans", href: "/for-fans" },
  { label: "Licensees", href: "/for-licensees" },
  { label: "Licensors", href: "/for-licensors" },
  { label: "About", href: "/about-egeez" },
  { label: "Research", href: "/research" },
  { label: "Notes", href: "/notes" },
];

export const LOGO_SRC = "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/4k4shif0_Egeez%20Logo.png";

// ----- HOME page features (scraped exactly) -----
export const FEATURES = [
  {
    id: "gifts",
    title: "Gifts",
    body: "Send digital gift cards from eGeez to your loved ones, redeemable for their favorite licensed products. It's the perfect way to gift something unique and officially licensed",
    bg: "#9747FF",
    color: "#FFFFFF",
    icon: "/assets/egeez/DBO6OuwLblJHDXmKa71jG5.png",
    images: [
      "/assets/egeez/BxYOnr5p4z5HJ0wBHZqdxZ.png",
      "/assets/egeez/Iyf6uZH7pqFKR25qpn7aii.png",
      "/assets/egeez/IklZ3AD4s1pJcLHYi8UEvX.png",
    ],
    span: "tall",
    overlayDark: true,
  },
  {
    id: "sorting-hat",
    title: "eGeez Sorting Hat",
    body: "Register your preferences to see your favorite licensed products under the Sorting Hat icon. Easily search for other products on the main feed anytime.",
    bg: "#D4F8FF",
    color: "#2B2A29",
    images: ["/assets/egeez/FeQGKaMr1FWKyMNlURv08Y.png"],
    span: "wide",
  },
  {
    id: "voice",
    title: "Voice",
    body: "Find what you want faster using voice search on the eGeez app. Just speak, and we'll handle the rest.",
    bg: "#FCFF6F",
    color: "#2B2A29",
    images: ["/assets/egeez/DLN8HQmGv3hIyAqM4U0iR5.png"],
    span: "small",
  },
  {
    id: "experiences",
    title: "Experiences",
    body: "Book unique official licensed experiences and themed hotels directly through eGeez curated just for the fans.",
    bg: "#FFFFFF",
    color: "#1F1F1F",
    images: [
      "/assets/egeez/G9cO3WNUQHAKWXVWBhALBa.png",
      "/assets/egeez/JDfgh8CJ29KHmo8fm0omp.png",
      "/assets/egeez/NJ8bM5T3ZmHqlNQwJBGk7.png",
    ],
    span: "wide",
  },
  {
    id: "gems",
    title: "Gems",
    body: "Earn Gems with every purchase and collect them to pay. We've made collecting rewards easy and rewarding.",
    bg: "#4F7B74",
    color: "#FFFFFF",
    images: [
      "/assets/egeez/IrtLNCvJuVCILlt6kCDL8x.png",
      "/assets/egeez/GkN1lzokzxVHFpp434RtDN.png",
      "/assets/egeez/Cag1dVT2UieHX72HOYj4N2.png",
      "/assets/egeez/E8RFDmeiv0QKjJf0DmQ2bl.png",
    ],
    span: "small",
    overlayDark: true,
  },
  {
    id: "geofencing",
    title: "Geofencing\nLicensed Products",
    body: "With eGeez's geofencing feature, discover licensed products available in your region without the frustration of finding out they can't ship to you due to licensing restrictions.\n\nA seamless search experience, geolocated!",
    bg: "#47FF7B",
    color: "#2B2A29",
    images: ["/assets/egeez/EzT6OHLkrTWJRrt7hr2RgD.png"],
    span: "tall",
  },
];

// Big "Unlimited Licensed Products" section
export const UNLIMITED = {
  title: "Unlimited Licensed\nProducts of your\nfavourite characters",
  body:
    "Access a vast selection of officially licensed products only featuring your favorite characters. Enjoy exclusive licensed products curated just for you, which you never knew existed!",
  images: [
    "/assets/egeez/GFUcJEtoQJAKyn46Os4a32.png",
    "/assets/egeez/Gr4bHVoa2H0JKgsmEdtY7m.png",
    "/assets/egeez/HGMT8cGqPJTHd8Eo8Ia6tb.png",
    "/assets/egeez/HsdD1pG4dwGH5RqOvY5TY4.png",
    "/assets/egeez/EKRvW8rifwCGuixGKQk5Ru.png",
    "/assets/egeez/D7sinEz4FqSJZNEAUIo7x3.png",
  ],
};

export const VERIFICATION = {
  title: "Verification & Counterfeit",
  body:
    "Enjoy peace of mind online with Egeez's fully verified licensees, ensuring only authentic, trademarked products. No counterfeits—just trusted, official merchandise.",
  images: [
    "/assets/egeez/CBQgSJFitMBKYSiJJU2kyK.png",
    "/assets/egeez/Dg30POfmbv1IW288hyomd9.png",
    "/assets/egeez/DEMdpIfHz56JF2efehc0LP.png",
    "/assets/egeez/B60DBQZ4mZXG6em9cq2BxX.png",
    "/assets/egeez/FvVtNNl4Q3jG0MArBTMGdE.png",
  ],
};

// Footer composite
export const FOOTER = {
  happinessCenter: {
    title: "Friends Happiness Center",
    note: "Tell me anything because I kinda care!",
    cta: "Tell Me Anything",
    image1: "/assets/egeez/jpYEhRhNqVGngB2weRsms.png",
    image2: "/assets/egeez/IeRIurTc32dH90oPp0KCBI.png",
  },
  installApp: {
    title: "Install The App",
    body: "Connect with official licensees directly for verified licensed products at lower prices.",
    appstore: "/assets/egeez/E639otPJsjqINT6kZGyDo9.png",
    playstore: "/assets/egeez/VaTyxPzWGZJFeDLGJ9ZY9.png",
    decoration: "/assets/egeez/DZpdhDheeDCIDGN4AYpfm3.png",
    character: "/assets/egeez/CmNshD5ExOcG4kknKTOwjq.png",
  },
  links: {
    column1: [
      { label: "Knowledge Base", href: "#" },
      { label: "Requirements for Licensees", href: "#" },
      { label: "Medium Articles", href: "https://medium.com" },
      { label: "eGeez World", href: "#" },
      { label: "eGeez Academy", href: "#" },
    ],
    column2: [
      { label: "Instagram", href: "https://instagram.com", icon: "instagram" },
      { label: "X", href: "https://x.com", icon: "x" },
      { label: "Discord", href: "https://discord.com", icon: "discord" },
      { label: "Linkedin", href: "https://linkedin.com", icon: "linkedin" },
    ],
    contact: {
      email: "Support@egeez.com",
      address: "150 King St. Toronto, ON,\nCanada, M5H 1J9",
      mapPin: "/assets/egeez/KbVihhdzcB7JTodv3dBzmv.png",
      mailIcon: "/assets/egeez/GxwvonxIzHgHLODHFy7vPw.png",
    },
    legal: [
      { label: "Privacy Policy", href: "#" },
      { label: "Terms of Use", href: "#" },
      { label: "Refund Policy", href: "#" },
    ],
  },
};
